<img class="xp-doc-thumb__img"
     [class.xp-doc-thumb__img--empty]="isEmpty()"
     [src]="imageSrc()"
     [alt]="label()"
     (error)="onImageError()" />
<span *ngIf="label()" class="xp-doc-thumb__label">{{ label() }}</span>
<span *ngIf="caption()" class="xp-doc-thumb__caption" [title]="caption()">{{ caption() }}</span>
<span *ngIf="note()" class="xp-doc-thumb__note">{{ note() }}</span>
